import { GLOBAL_THEME_COLOR } from '@constants/theme';

export const cellSize = 130;
export const perMinuteCellSize = cellSize / 60;
export const cellHeight = 55;
export const cellXSpacing = 4;
export const cellYSpacing = 4;
export const gridCellRows = 10;

export const INACTIVE_TIME = 2;

export const hoursOfDayColor = (hours: number, openHour: number, closedHour: number) => {
  if (isMorning(hours) && hours >= openHour) return '#eaf5fc';
  if (isEvening(hours)) return '#fcefe9';
  if (isAfternoon(hours) && hours < closedHour) return '#ede5fe';
  return GLOBAL_THEME_COLOR.$dark_secondary_color;
};
export const isMorning = (hours: number) => hours < 12;
export const isEvening = (hours: number) => hours >= 12 && hours <= 17;
export const isAfternoon = (hours: number) => hours > 17;
